import React from 'react';
export function FolderOpenIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.035 3H2v18h17l5-8.5V11h-2V6H11.035l-2-3zM20 11V8H9.965l-2-3H4v11.1L7 11h13zm-2.144 8H4.614l3.53-6h13.242l-3.53 6z"
  }));
}